import OapFlowplayerPopin from './code/Scripts/components/OapFlowplayerPopin.vue';

export default {
  components: {
    OapFlowplayerPopin,
  },
};
